
export const uploadsUrl = process.env.CONTENT_URL || 'https://uploads.dupixentvirtualbooth.com/aad2021congress-3f37e3f2-86ae-4a99-9310-b5392a0f3c6d'
export const contentUrl = `${uploadsUrl}/content`
export const videoContentUrl = `${contentUrl}/videos`
export const pdfContentUrl = `${contentUrl}/pdfs`
export const pdfViewer = `${uploadsUrl}/pdf/web/viewer.html`
